import React, { createContext, useContext, useState } from "react";

// Define theme properties for each theme
export const themes = {
  default: {
    name: "default",
    backgroundColor: "#000000",
    textColor: "#fee", // Light cream color for text
    logoVariant: "white",
  },
  theme1: {
    name: "theme1",
    backgroundColor: "#f9f2ea", // Light beige
    textColor: "#000000", // Black text
    logoVariant: "black",
  },
  theme2: {
    name: "theme2",
    backgroundColor: "#f2f2f2", // Medium gray
    textColor: "black", // Light cream color for text
    logoVariant: "black",
  },
};

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(themes.default);

  const setThemeByName = (themeName) => {
    setTheme(themes[themeName] || themes.default);
  };

  return (
    <ThemeContext.Provider value={{ theme, setThemeByName }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
